// Client-Side Demo Preview Mode (Feb 2026)
//
// Frontend-only toggle that swaps live API responses for realistic fixtures.
// Used so the mobile team (who can't run the backend seed script) can
// regression-test Matches / Likes / Messages / Views UI against a stable,
// reproducible snapshot on the web bundle they share with mobile.
//
// Storage: localStorage key `mtk_demo_mode_v1` ∈ {"1", null}.
// Listeners: `subscribe(fn)` gets called every time the flag flips so any
// component (banner, Settings toggle) can re-render.

const STORAGE_KEY = 'mtk_demo_mode_v1';
const listeners = new Set();

function read() {
  try { return localStorage.getItem(STORAGE_KEY) === '1'; }
  catch { return false; }
}

let _enabled = read();

export const demoMode = {
  isEnabled() { return _enabled; },
  enable() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
    _enabled = true;
    listeners.forEach(fn => { try { fn(true); } catch { /* ignore */ } });
  },
  disable() {
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    _enabled = false;
    listeners.forEach(fn => { try { fn(false); } catch { /* ignore */ } });
  },
  toggle() { _enabled ? this.disable() : this.enable(); },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
